/* eslint-disable @typescript-eslint/no-explicit-any */

import { useEffect, useRef } from 'react'
import Highcharts, { Chart } from 'highcharts'
import HC_map from 'highcharts/modules/map'
HC_map(Highcharts)

interface BaseChartProps {
  options: any
  id: string
  isMap?: boolean
}

const BaseChart = ({ options, id, isMap = false }: BaseChartProps) => {
  const chartRef = useRef<Chart | null>(null)

  useEffect(() => {
    if (isMap && Highcharts.mapChart) {
      chartRef.current = Highcharts.mapChart(id, options)
    } else {
      chartRef.current = Highcharts.chart(id, options)
    }

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy()
      }
    }
  }, [options, id, isMap])

  return (
    <div
      id={id}
      style={{
        width: '100%',
      }}
    />
  )
}

export default BaseChart
